<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="single-page"
    id="home-page"
  >
    <PageHeader />
    <ModuleBuilder
      v-if="currentPage.acf && currentPage.acf.modules"
      class="modules"
      :modules="currentPage.acf.modules"
    />
    <DynamicHtml
      class="padding_large"
      v-if="currentPage.content.rendered"
      role="content"
      >{{ currentPage.content.rendered }}</DynamicHtml
    >
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
export default {
  name: "single-page",
  components: {},
  data() {
    return {};
  },
  computed: {}
};
</script>
<style lang="scss">
@import "./../assets/scss/style.scss";
</style>
